import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAuthData } from "./authSlice";

export const fetchInvoices = createAsyncThunk(
  "invoices/fetchInvoices",
  async (_, { rejectWithValue }) => {
    try {
      const authData = getAuthData();

      if (!authData?.token || !authData?.groupCode || !authData?.companyCode) {
        throw new Error("signin");
      }
      const formData = new FormData();
      formData.append("token", authData?.token);
      formData.append("company", authData?.company);
      formData.append("aux", authData?.aux);

      const response = await fetch(
        process.env.REACT_APP_API_URL + "clientPortal/Unpaid_invoices",
        {
          method: "POST",
          body: formData,
        },
      );

      if (!response.ok) {
        throw new Error("Failed to fetch orders history");
      }

      const data = await response.json();

      return data;
    } catch (error) {
      return rejectWithValue("Failed to fetch invoices");
    }
  },
);

const invoicesSlice = createSlice({
  name: "invoices",
  initialState: {
    items: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInvoices.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchInvoices.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.items = action.payload;
      })
      .addCase(fetchInvoices.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default invoicesSlice.reducer;
